import { createStyles, Theme } from '@material-ui/core/styles';

import { colours } from '@shared/theme/colours';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {},

    comingSoon: {
      color: colours.neutral[600],
      fontSize: '16px',
      fontStyle: 'italic',
      padding: spacing(3),
      textAlign: 'center',
    },

    content: {
      padding: spacing(3),
    },

    errorMessage: {
      color: colours.error[500],
      fontSize: '14px',
      marginTop: spacing(1),
    },

    loading: {
      color: colours.neutral[600],
      fontSize: '16px',
      padding: spacing(3),
      textAlign: 'center',
    },

    newAddressFlow: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(2),
    },

    noProperties: {
      color: colours.neutral[600],
      fontSize: '16px',
      fontStyle: 'italic',
      padding: spacing(3),
      textAlign: 'center',
    },

    optionTitle: {
      fontSize: '16px',
      fontWeight: 500,
    },

    propertyList: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(1.5),
    },

    propertySelection: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(2),
    },

    propertySourceOption: {
      border: `1px solid ${colours.neutral[300]}`,
      borderRadius: '8px',
      cursor: 'pointer',
      padding: spacing(2),
      transition: 'all 0.2s ease',
      '&:hover': {
        backgroundColor: colours.neutral[100],
        borderColor: colours.brandNavy[500],
      },
    },

    propertySourceOptions: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(1.5),
    },

    propertySourceSelection: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(2),
    },

    publishOptionsContent: {
      flex: 1,
      overflow: 'auto',
      padding: spacing(3),
    },

    sectionTitle: {
      color: colours.neutral[800],
      fontSize: '18px',
      fontWeight: 'bold',
      marginBottom: spacing(2),
    },

    selected: {
      backgroundColor: colours.brandNavy[100],
      borderColor: colours.brandNavy[500],
    },

    tenureHeading: {
      fontSize: '16px',
      fontWeight: 600,
      margin: 0,
      marginBottom: spacing(2),
    },

    tenureOptions: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(1.5),
    },
  });
